import React, { useEffect, useRef, useState } from 'react';

const LaunchTeaser = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="relative py-32 px-6 bg-slate-950"
      data-component-path="client/src/components/LaunchTeaser.jsx"
      data-component-line="1:5"
      data-component-id="client/src/components/LaunchTeaser.jsx:1:5"
    >
      <div 
        className="max-w-4xl mx-auto text-center"
        data-component-path="client/src/components/LaunchTeaser.jsx"
        data-component-line="2:7"
        data-component-id="client/src/components/LaunchTeaser.jsx:2:7"
      >
        <div 
          className={`transform transition-all duration-1000 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
          data-component-path="client/src/components/LaunchTeaser.jsx"
          data-component-line="3:9"
          data-component-id="client/src/components/LaunchTeaser.jsx:3:9"
        >
          <div 
            className="inline-block mb-6 px-6 py-2 border border-slate-700 rounded-full"
            data-component-path="client/src/components/LaunchTeaser.jsx"
            data-component-line="4:11"
            data-component-id="client/src/components/LaunchTeaser.jsx:4:11"
          >
            <span 
              className="text-sm font-medium text-slate-400 tracking-widest uppercase"
              data-component-path="client/src/components/LaunchTeaser.jsx"
              data-component-line="5:13"
              data-component-id="client/src/components/LaunchTeaser.jsx:5:13"
            >
              Coming Soon
            </span>
          </div>

          <h2 
            className="text-5xl md:text-7xl font-black text-slate-100 mb-6 tracking-tight"
            data-component-path="client/src/components/LaunchTeaser.jsx"
            data-component-line="6:11"
            data-component-id="client/src/components/LaunchTeaser.jsx:6:11"
          >
            Q3 2026
          </h2>

          <p 
            className="text-xl md:text-2xl text-slate-400 font-light leading-relaxed max-w-2xl mx-auto"
            data-component-path="client/src/components/LaunchTeaser.jsx"
            data-component-line="7:11"
            data-component-id="client/src/components/LaunchTeaser.jsx:7:11"
          >
            Something is coming. Something that will change how you connect with the ground beneath you.
          </p>
        </div>
      </div>

      {/* Ambient glow effect */}
      <div 
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-slate-700 rounded-full blur-3xl opacity-10 pointer-events-none"
        data-component-path="client/src/components/LaunchTeaser.jsx"
        data-component-line="8:7"
        data-component-id="client/src/components/LaunchTeaser.jsx:8:7"
      ></div>
    </section>
  );
};

export default LaunchTeaser;